import type { ThreadSummary } from "../../../../api/threads/threadDecoders";
import { byRecentActivity } from "../../list/projectThreads";
import type { ThreadSubject } from "../threadIntent";

/** How many earlier runs the preparation offers; older ones are in the Threads list. */
export const EARLIER_RUNS_SHOWN = 8;

/**
 * The project's Threads on the same document as `subject`, at any version or segment, newest
 * activity first (F30): the runs a new start can continue or branch from. A Thread's subject
 * is `<document>@<version>[#<segment>]`.
 */
export function earlierRunsOn(threads: readonly ThreadSummary[], subject: ThreadSubject): readonly ThreadSummary[] {
  const prefix = `${subject.document.documentId}@`;
  return threads
    .filter((thread) => thread.subject?.startsWith(prefix) === true)
    .toSorted(byRecentActivity)
    .slice(0, EARLIER_RUNS_SHOWN);
}
